import React from 'react';
import { Row, Col } from 'antd';
import moment from 'moment';
import { STATIC_RESOURCE } from '../../../origin';
const Print = ({ info = {} }) => {
  const STATUS = {
    1: '合格',
    2: '退货',
    3: '换货',
    4: '扣收'
  };
  const columns = [
    {
      title: '序号',
      dataIndex: 'id',
      align: 'center',
      width: 50
    },
    {
      title: '商品名称',
      dataIndex: 'sale_name',
      align: 'center',
      width: 100
    },
    {
      title: '商品单位',
      dataIndex: 'item_unit',
      align: 'center',
      width: 100
    },
    {
      title: '到货数量',
      dataIndex: 'arrival_number',
      align: 'center',
      width: 100
    },
    {
      title: '抽检率',
      dataIndex: 'sampling_rate',
      align: 'center',
      width: 100
    },
    {
      title: '抽检数量/重量',
      dataIndex: 'sampling_number',
      align: 'center',
      width: 120
    },
    {
      title: '不合格重量/数量',
      dataIndex: 'unqualified_number',
      align: 'center',
      width: 120
    },
    {
      title: '不合格比例',
      dataIndex: 'unqualified_rate',
      align: 'center',
      width: 100
    },
    {
      title: '现场图片',
      dataIndex: 'scene_images',
      align: 'center',
      width: 200,
      render: (arr, record) => {
        return (
          <>
            {
              arr.map(item => {
                return <span key={item.url} style={{ width: '50px', height: '50px', display: 'inline-block', marginRight: 8 }}><img alt='' key={item.url} src={item.url} width={'100%'} height={'100%'} /></span>;
              })
            }
          </>
        );
      }
    },
    {
      title: '处理方式',
      dataIndex: 'handling_type',
      align: 'center',
      width: 100
    },
    {
      title: '退/换/扣数量',
      dataIndex: 'abnormal_number',
      align: 'center',
      width: 100
    },
    {
      title: '具体原因',
      dataIndex: 'abnormal_reason',
      align: 'center',
      width: 100
    },
    {
      title: '供应商',
      dataIndex: 'supplier_name',
      align: 'center',
      width: 100
    },
    {
      title: '糖度检测',
      dataIndex: 'brix',
      align: 'center',
      width: 100
    },
    {
      title: '采购员',
      dataIndex: 'purchaser',
      align: 'center',
      width: 100
    },
    {
      title: '质检员',
      dataIndex: 'qualityer',
      align: 'center',
      width: 100
    },
    {
      title: '抽检次数',
      dataIndex: 'quality_number',
      align: 'center',
      width: 100
    },
    {
      title: '备注',
      dataIndex: 'remark',
      align: 'center',
      width: 100
    },
  ];
  const print_table_style = {
    textAlign: 'center'
  };
  return (
    <div className='i-print-wrapper'>
      <div style={{ margin: '22px auto', textAlign: 'center' }}>
        <img src={`${STATIC_RESOURCE}/cp_purchase/index/logo.png`} alt='' />
      </div>
      <div style={{ marginTop: 24 }}>
        <div>{info?.create_time ? moment(info?.create_time).format('YYYY年MM月DD日') : ''}质检情况：</div>
        <div style={{ marginTop: 24 }}>
          <div style={{ color: '#1890FF' }}>总体指标：</div>
          <Row gutter={24} style={{ display: 'flex' }}>
            <Col style={{ marginTop: 20, flex: 1 }}>商品数量：{info.products_count}</Col>
            <Col style={{ marginTop: 20, flex: 1 }}>合格率：{info.type_rate_1 === '-' ? info.type_rate_1 : `${info.type_rate_1}%`}</Col>
            <Col style={{ marginTop: 20, flex: 1 }}>退货率：{info.type_rate_2 === '-' ? info.type_rate_2 : `${info.type_rate_2}%`}</Col>
            <Col style={{ marginTop: 20, flex: 1 }}>换货率：{info.type_rate_3 === '-' ? info.type_rate_3 : `${info.type_rate_3}%`}</Col>
            <Col style={{ marginTop: 20, flex: 1 }}>扣重收货率：{info.type_rate_4 === '-' ? info.type_rate_4 : `${info.type_rate_4}%`}</Col>
          </Row>
        </div>
        <div style={{ marginTop: 24 }}>
          <div style={{ color: '#1890FF' }}>品类指标：</div>
          <Row gutter={24}>
            {
              Array.isArray(info.category_index) && info.category_index.length > 0 &&
              info.category_index.map((item, i) => {
                return <Col key={i} span={12} style={{ margin: '22px 0' }}>
                  {item.category_name}抽检{item.products_count}个单品：
                  {
                    item.abnormal.map((item, k) => {
                      return <span key={k}>{item.abnormal_type}{item.abnormal_couont}个SKU,</span>;
                    })
                  }
                  <span> 合格率{item.pass_rate}%</span>
                </Col>;
              })
            }
          </Row>
        </div>
        <div style={{ marginTop: 24 }}>
          <div style={{ color: '#1890FF' }}>商品指标：</div>
          <table border="1" style={{ border: '1px solid #CCC', width: '100%', borderCollapse: 'collapse', display: 'block', overflow: 'auto' }}>
            <thead>
              <tr>
                {
                  columns.map((item, i) => {
                    return <th key={i} style={print_table_style}>{item.title}</th>;
                  })
                }
              </tr>
            </thead>
            <tbody>
              {info?.products?.map((item) => (
                <tr key={item.id}>
                  {
                    columns.map((temp, k) => {
                      return <td key={k} style={{...print_table_style, width:temp.width}}>
                        {temp.dataIndex === 'scene_images' ?
                          item.scene_images.map(item => {
                            return <span key={item.url} style={{ width: '50px', height: '50px', display: 'inline-block', marginRight: 8 }}><img alt='' key={item.middle_thumb_url} src={item.middle_thumb_url} width={'100%'} height={'100%'} /></span>;
                          })
                          : (temp.dataIndex === 'sampling_rate' || temp.dataIndex === 'unqualified_rate') ? (item[temp.dataIndex] + '%') : temp.dataIndex === 'handling_type' ? STATUS[item[temp.dataIndex]] : item[temp.dataIndex]}
                      </td>;
                    })
                  }
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>

    </div>
  );
};

export default Print;